module.exports = __webpack_public_path__ + "static/img/practiceSystem_07.77b9ab1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/practiceSystem_07.png
// module id = CUQb
// module chunks = 23